import { AbstractControl, ValidationErrors, ValidatorFn } from "@angular/forms";


export const tmsEndAfterStartValidator: ValidatorFn = (control: AbstractControl): ValidationErrors | null => {

	const ce_dateStart = control.get( 'ce_dateStart' );
	if( !ce_dateStart ) return null;
	const ce_timeStart = control.get( 'ce_timeStart' );
	if( !ce_timeStart ) return null;
	const ce_dateEnd = control.get( 'ce_dateEnd' );
	if( !ce_dateEnd ) return null;
	const ce_timeEnd = control.get( 'ce_timeEnd' );
	if( !ce_timeEnd ) return null;

	if( ce_dateStart.value === null ) return null;

	const tmsStart = convertStrToDate(
		"" + ce_dateStart.value,
		"" + ce_timeStart.value
	);

	if( ce_dateEnd.value === null ) return null;

	const tmsEnd = convertStrToDate(
		"" + ce_dateEnd.value,
		"" + ce_timeEnd.value
	);

	if( tmsStart <= tmsEnd ) {
		ce_dateEnd.setErrors( null );
		return null;
	}
	else {
		ce_dateEnd.setErrors( { tmsEndBeforeStart: true } );
		return { tmsEndBeforeStart: true };
	}

};

function convertStrToDate( strDay: string, strTime: string ): number {

	const dt = new Date();
	dt.setHours( 0, 0, 0, 0 );

	const arr = strDay.split( "-" );
	if( arr && arr.length && arr.length == 3 ) {

		dt.setFullYear( +arr[0], +arr[1]-1, +arr[2] );

		if( strTime ) {
			const arr2 = strTime.split( ":" );
			if( arr2 && arr2.length && arr2.length == 3 ) {
				dt.setHours( +arr2[0], +arr2[1], +arr2[2] );
			}
		}

	};
	return dt.getTime();

}